var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh2Blue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 24C44.5 35.04 35.54 44 24.5 44C13.46 44 6.72 32.88 6.72 32.88M6.72 32.88H15.76M6.72 32.88V42.88M4.5 24C4.5 12.96 13.38 4 24.5 4C37.84 4 44.5 15.12 44.5 15.12M44.5 15.12V5.12M44.5 15.12H35.62",
    stroke: "#3C81FB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh2Blue);
export default __webpack_public_path__ + "static/media/refresh-2-blue.9201cac3264be1888a1efac355cc7ef6.svg";
export { ForwardRef as ReactComponent };